import { motion } from 'framer-motion';

import s from './BoardTabLabel.module.scss';

/** Подпись вкладки; подчёркивание одно на все вкладки и переезжает к активной */
const BoardTabLabel = ({ text, isActive }: { text: string; isActive: boolean }) => (
  <>
    {text}
    {isActive && <motion.span layoutId="boardTabIndicator" className={s.indicator} />}
  </>
);

export { BoardTabLabel };
